<template functional>
  <div class="life-loader">
    <div class="sk-wave">
      <img src="/assets/img/loader.gif"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLoader',
};
</script>

<style scoped>
.turn-element {
  animation: roll 0.5s infinite;
  transform: rotate(360deg);
}

@keyframes roll {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.life-loader {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:  white;
  opacity: 0.7;
  z-index: 99999999;
}
.sk-wave {
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sk-rect {
  background: #fff;
  margin-right: 2px;
  box-shadow: 0 0 5px #565656;
}

.sk-wave img {
  width: 400px;
}
</style>
